import React from 'react'

function IconClose() {
  return (
    <svg className="icon icon--close-circle u-ml-0 u-mr-0">
      <use xlinkHref="#icon-close-circle" />
    </svg>
  )
}

export default IconClose
